import { render, staticRenderFns } from "./icon-link.vue?vue&type=template&id=6434afc8"
import script from "./icon-link.vue?vue&type=script&lang=ts"
export * from "./icon-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports